import {
  IAPIError
} from '@literax/models/http/api/error.model';
import {
  IShowSignatureResponse
} from '@literax/models/http/api/signature.model';

export interface IFreeSignatureState {
  signatureResult: any;
  showSignatureResult: IShowSignatureResponse;
  errors: IAPIError;
}

export const initialFreeSignatureState: IFreeSignatureState = {
  signatureResult: null,
  showSignatureResult: null,
  errors: null
};
